import { save, openWhatsapp, getMeta, isDesktop, getMessage, isSendMessageToWhatsappEnabled } from '../store.js';
import axios from 'axios';

(($) => {

    // Formidable integration is a FormyChat Ultimate feature.
    if (!formychat_vars.is_premium) return;

    // For Ajax
    async function handleFormSubmission(object, form) {

        console.log('handleFormSubmission', object, form);

        const formId = form.querySelector('input[name="form_id"]').value || null;

        if (!formId) return;

        // Make an AJAX request to get the entry data.
        // The server uses session-based verification to ensure only the form submitter
        // can retrieve their own entry data (transient stored during frm_after_create_entry).
        const rest = await axios.post(formychat_vars.ajax_url, null, {
            params: {
                action: 'formychat_get_formidable_entry',
                form_id: formId
            }
        });

        // If the request failed, log the error and return.
        if (!rest.data.success) {
            console.warn('FormyChat: Failed to retrieve entry data:', rest.data);
            return;
        }

        const result = rest.data.data || {};

        const widget = document.querySelector('[data-whatsapp]');
        // console.log('widget', widget);


        if (widget) {

            // Inside widget.
            const widgetId = widget.dataset.widget;
            if (!widgetId) return;

            const widgetObject = formychat_vars.data.widgets.find(widget => widget.id == widgetId);
            if (!widgetObject) return;

            const whatsappConfig = { ...(widgetObject.config.whatsapp || {}), widget_id: widgetId };
            const { new_tab, web_version, formidable_message_template, destination_type, group_invite_code } = whatsappConfig;
            const whatsappNumber = destination_type === 'group' && group_invite_code ? group_invite_code : widget.dataset.whatsapp;
            const message = getMessage(formidable_message_template, result.inputs);

            const data = {
                form: 'formidable',
                form_id: formId,
                field: result.inputs,
                meta: getMeta.value,
                widget_id: widgetId,
            }

            try {
                const targetOrigin = (typeof formychat_vars !== 'undefined' && formychat_vars?.site?.url)
                    ? new URL(formychat_vars.site.url).origin
                    : '*';
                window.parent.postMessage({ formychat_submitted: JSON.parse(JSON.stringify(data)) }, targetOrigin);
            } catch (err) {
            }

            save(data, whatsappNumber, message, isDesktop() && web_version == 1, new_tab == 1);
            if (isSendMessageToWhatsappEnabled(whatsappConfig)) {
                openWhatsapp(whatsappNumber, message, isDesktop() && web_version == 1, new_tab == 1, whatsappConfig);
            }

        } else {

            const formychatConfig = result.formychat || {};
            const { destination_type, group_invite_code } = formychatConfig;
            const whatsappNumber = destination_type === 'group' && group_invite_code ? group_invite_code : (result.formychat.number || '');
            const { new_tab, web_version, formidable_message_template } = formychatConfig;
            const message = getMessage(formidable_message_template, result.inputs);

            const data = {
                form: 'formidable',
                form_id: formId,
                field: result.inputs,
                meta: getMeta.value,
                widget_id: null,
            }

            save(data, whatsappNumber, message, isDesktop() && web_version == 1, new_tab == 1);
            openWhatsapp(whatsappNumber, message, isDesktop() && web_version == 1, new_tab == 1, formychatConfig);

        }
    }

    $(document).on('frmFormComplete', handleFormSubmission)


    // For Non-ajax forms.
    window.formychat_formidable_submit = (object) => {

        const widget = document.querySelector('[data-whatsapp]');

        if (widget) {
            const widgetId = widget.dataset.widget;
            if (!widgetId) return;

            const widgetObject = formychat_vars.data.widgets.find(widget => widget.id == widgetId);
            if (!widgetObject) return;

            const whatsappConfig = { ...(widgetObject.config.whatsapp || {}), widget_id: widgetId };
            const { new_tab, web_version, formidable_message_template, destination_type, group_invite_code } = whatsappConfig;
            const whatsappNumber = destination_type === 'group' && group_invite_code ? group_invite_code : widget.dataset.whatsapp;
            const message = getMessage(formidable_message_template, object.inputs);

            const data = {
                form: 'formidable',
                form_id: object.form_id,
                field: object.inputs,
                meta: getMeta.value,
                widget_id: widgetId,
            }

            try {
                const targetOrigin = (typeof formychat_vars !== 'undefined' && formychat_vars?.site?.url)
                    ? new URL(formychat_vars.site.url).origin
                    : '*';
                window.parent.postMessage({ formychat_submitted: JSON.parse(JSON.stringify(data)) }, targetOrigin);
            } catch (err) {
            }

            save(data, whatsappNumber, message, isDesktop() && web_version == 1, new_tab == 1);
            if (isSendMessageToWhatsappEnabled(whatsappConfig)) {
                openWhatsapp(whatsappNumber, message, isDesktop() && web_version == 1, new_tab == 1, whatsappConfig);
            }

        } else {

            const settings = object.formychat || {};
            if (!settings || !settings.status) return;
            const { number, message, new_tab, web_version, destination_type, group_invite_code } = settings;
            const to = destination_type === 'group' && group_invite_code ? group_invite_code : number;
            const formidableMessage = getMessage(message, object.inputs);

            const data = {
                form: 'formidable',
                form_id: object.form_id,
                field: object.inputs,
                meta: getMeta.value,
                widget_id: null,
            }

            save(data, to, formidableMessage, isDesktop() && web_version == 1, new_tab == 1);
            openWhatsapp(to, formidableMessage, isDesktop() && web_version == 1, new_tab == 1, settings);

        }
    }

    // Trigger custom event that formychat_formidable_loaded
    const event = new CustomEvent('formychat_formidable_loaded', {
        detail: {
            formychat_formidable_loaded: true
        }
    });
    document.dispatchEvent(event);

})(jQuery)
